module.exports = __webpack_public_path__ + "static/media/logo-white.d390cc26.svg";